import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { Modal } from 'antd';
export default function Model({ isOpen, onDismiss, children, }) {
    return (_jsx(Modal, { open: isOpen, onCancel: onDismiss, footer: null, closable: false, centered: true, zIndex: 10000, maskClosable: true, style: {
            fontFamily: 'var(--netx-font)',
        }, mask: true, className: 'ModelContainer', children: children }));
}
